import {   
    BaseLayerFactory_3857,
    BaseLayerType
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import { Buckinghamshire_BaseLayers } from "./Client/Buckinghamshire_BaseLayers";
import { Cheshire_BaseLayers } from "./Client/Cheshire_BaseLayers";
import { Merseyside_BaseLayers } from "./Client/Merseyside_BaseLayers";
import { SouthYorkshire_BaseLayers } from "./Client/SouthYorkshire_BaseLayers";
import { LhlpBaseLayers } from "./LhlpBaseLayerFactory";

//Not needed for showing 27700 on 3857?
//proj4.defs("EPSG:27700", "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs");
//register(proj4);
//const  proj27700 = getProjection('EPSG:27700');
//proj27700.setExtent([0, 0, 700000, 1300000]);

export class ClientBaseLayerFactory extends BaseLayerFactory_3857 {

    private bucksBaseLayers = new Buckinghamshire_BaseLayers();
    private southYorkshireBaseLayers = new SouthYorkshire_BaseLayers();
    private cheshireBaseLayers = new Cheshire_BaseLayers();
    private merseysideBaseLayers = new Merseyside_BaseLayers();

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string = "", esdmApiKey: string = ""): IBaseLayer {

        switch (baseLayerType) {
            case LhlpBaseLayers.Buckinghamshire_OS:
                return this.bucksBaseLayers.GetBuckinghamshireOS();

            case LhlpBaseLayers.SouthYorkshire_OS:
                return this.southYorkshireBaseLayers.GetSouthYorkshireOS();

            case LhlpBaseLayers.Cheshire_OS:
                return this.cheshireBaseLayers.GetCheshireOS();

            case LhlpBaseLayers.Merseyside_OS:
                return this.merseysideBaseLayers.GetMerseysideOS();
        }


        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmApiKey);
    }  
}